module.exports = __webpack_public_path__ + "media/assets/airtutors-logo-square-d35ace6685dec0c4849d59dce39efdcf.png";